import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import {Invite, MemberServiceType} from '@/class/service-form.interface';
import {MemberInitState} from '@/store/member/member.types';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';
import moment from 'moment';

declare var google: any;

@Component({
  components: {}
})
export default class InviteDetailComponent extends Vue {
  @Action('_inviteMember', {namespace: 'member'}) inviteMember!: (payload: Invite[]) => Promise<any>;
  @State('member') memberState!: MemberInitState;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public inviteList = [] as Invite[];
  public inviteForm = {
    serviceTime: '',
    serviceDate: '',
    serviceRemark: '',
    serviceLocation: '',
    phone: ''
  };
  public refNo = (+new Date()).toString();
  public serviceType: number = 1;
  public locationIsRequire: boolean = false;

  @Watch('$route.query')
  queryChange(val:string) {
    this.fetchServiceType();
  }

  mounted() {
    // let rdy = false;
    // let autocomplete: any;
    // let index = setInterval(() => {
    //   if (google) {
    //     rdy = true;
    //     let eventLocation = this.$refs.eventLocation;
    //     autocomplete = new google.maps.places.Autocomplete(
    //       eventLocation,
    //       {types: ['geocode']});
    //   }
    //   if (rdy) {
    //     clearInterval(index);
    //     google.maps.event.addListener(autocomplete, 'place_changed', () => {
    //       let place = autocomplete.getPlace();
    //       let long_name = place.address_components.map((add: any) => {
    //         return add.long_name;
    //       });
    //       this.inviteForm.serviceLocation = long_name.join(',');
    //     });
    //   }
    // }, 1000);
    this.fetchServiceType();
  }

  fetchServiceType() {
    let {serviceType} = this.$route.query;
    this.serviceType = parseInt(serviceType as string);
    this.locationIsRequire = this.serviceType === 2;

  }
  async inviteClick() {
    this.inviteList = this.memberState.inviteList;
    console.log('DEBUG: this.inviteList', JSON.stringify(this.inviteList));
    let forms = document.getElementsByClassName('inviteDetail');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }
    this.Loading(true);
    this.inviteList = this.inviteList.map((row) => {
      row.serviceDate = moment(`${this.inviteForm.serviceDate} ${this.inviteForm.serviceTime}`
        , 'YYYY-MM-DD HH:mm').utc().toDate();
      row.remark = this.inviteForm.serviceRemark;
      row.location = this.inviteForm.serviceLocation;
      row.refNo = this.refNo;
      row.phone = this.inviteForm.phone;
      return row
    });
    let res = await this.inviteMember(this.inviteList);
    if (res.status === 201) {
      this.Toast({
        heading: '!',
        message: 'ส่งคำเชิญสำเร็จแล้ว',
        type: 'success'
      }).then();
      await this.$router.push('/');
    } else {
      this.Toast({
        heading: '!',
        message: 'เกิดข้อผิดพลาดกรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง',
        type: 'danger'
      }).then();
    }
    this.Loading(false);

  }
}
